// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"99694dab","488":"accec8b6"}[chunkId] + ".chunk.js";
};